/* SpawnAnything — terrain presets for the sandbox "Gelände" choice (pure, worker-safe).
   'flach' means no terrain at all (the classic flat field). */
import { generateTerrain } from './terrain.js';

export const TERRAIN_PRESETS = {
  flach: { name: 'Flach', opts: null },
  huegel: { name: 'Hügel', opts: { levels: 3, river: false, paths: true, battleRadius: 120 } },
  terrassen: { name: 'Terrassen', opts: { levels: 5, river: false, paths: true, battleRadius: 70 } },
  flusstal: { name: 'Flusstal', opts: { levels: 4, river: true, paths: true, battleRadius: 110 } },
};
export const TERRAIN_KEYS = Object.keys(TERRAIN_PRESETS);

/** Map size shared by all presets: 460 m, n = 230 cells à 2 m (covers the paint arena ±230 m). */
export const TERRAIN_SIZE = 460, TERRAIN_CELL = 2;

/** Generate the terrain for a preset key and seed; null for 'flach' / unknown keys. */
export function terrainForPreset(key, seed) {
  const p = TERRAIN_PRESETS[key];
  if (!p || !p.opts) return null;
  return generateTerrain({ seed: (seed >>> 0) || 1, size: TERRAIN_SIZE, cell: TERRAIN_CELL, ...p.opts, maxTrees: 0, maxRocks: 0 });
}

/** Campaign missions: map.terrain { levels 0..3, river, battleRadius } → generateTerrain options (null = flat). */
export function terrainOptsFromMap(mt) {
  if (!mt || !(mt.levels > 0)) return null;
  return { levels: Math.min(5, (mt.levels | 0) + 2), river: !!mt.river, paths: true, battleRadius: mt.battleRadius || 120 };
}

/** The part of a terrain the simulation needs (typed arrays + scalars; structured-clone friendly). */
export function workerTerrain(t) {
  if (!t) return null;
  const { props, river, ...rest } = t;
  return rest;
}
